<style>
    .ly-button-import {
        display: inline-block;
    }
</style>
<template>
    <div class="ly-button-import">
        <el-button type="success" :size="size" @click="showUpload">
            <i class="fa fa-cloud-upload"></i>&nbsp;<slot></slot>
        </el-button>
        <el-dialog :visible.sync="dialogTableVisible" class="tc">
            <el-upload
                drag
                :action="api"
                :data="data"
                mutiple
                :before-upload="beforeUpload"
                :on-success="fileUploadSuccess"
                :on-error="fileUploadError">
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                <template slot='tip'>
                <div class="el-upload__tip">只能上传Excel文件</div>
                </template>
            </el-upload>
        </el-dialog>
    </div>
</template>
<script>
    export default {
        name: 'LyButtonImport',
        props: {
            size: {
                type: String,
                default: 'small'
            },
            api: String,
            data: {
                type: Object,
                default: () => {}
            },
            callback: Function
        },
        data () {
            return {
                dialogTableVisible: false
            }
        },
        methods: {
            showUpload () {
                this.dialogTableVisible = true
            },
            beforeUpload (file) {
                if (file.name.indexOf('.xls') < 1 && file.name.indexOf('.xlsx') < 1) {
                    this.$message({type: 'warning', message:'请选择Excel文件！'});
                    return false
                }
            },
            fileUploadSuccess (response, file, fileList) {
                this.dialogTableVisible = false
                if (response.status === 200) {
                    this.$message({
                        message: '上传成功',
                        type: 'success'
                    })
                    if (this.callback) {
                        this.callback()
                    }
                } else {
                    this.$message({
                        message: response.msg,
                        type: 'warning'
                    })
                }
            },
            fileUploadError (err, file, fileList) {
                this.$message({
                    message: err,
                    type: 'warning'
                })
            }
        }
    }
</script>